import {Modal} from 'bootstrap/js/index.esm';
import {
    addFavorite,
    boostAdChangeStep,
    favoriteFicha,
    initFancyBox,
    isMobileDevice,
    renderTooltip, showToastMsg,
    SVGLoader,
    translate
} from "./utils.esm";
import {customGaSetDimension, customGa} from "./ga-custom";
import favoritesFn from "./favorites-fn";

import {Swiper} from "swiper/bundle";

console.log('init FichaFn');
export const fichaFn = {
    swiper: undefined,
    settingsModalElement: undefined,
    settingsModal: undefined,
    boostModalElement: undefined,
    hasBoostModal: false,
    hasReportModal: false,
    reportModalElement: undefined,
    reportModal: undefined,
    value: undefined,
    audio: undefined,

    async initAdConversion(fichaId) {
        const {AdConversion} = await import('./ad-conversion');
        if(!this.adConversion)
            this.adConversion = await new AdConversion(fichaId);
        else
            await this.adConversion.init(fichaId);
    },
    async fichaEssentials(storiesEnabled) {
        await this.parseFichaDate();
        this.mobileFichaReplacements();

        if(storiesEnabled) {
            const {Stories} = await import('./stories');
            this.stories = new Stories();
            this.stories.initFicha();
        }

        if(isMobileDevice) {
            this.settingsModalElement = document.querySelector('#settingsModal');
            this.settingsModal = new Modal(fichaFn.settingsModalElement);
        }

        this.setVideoGaEvent();
        this.bindMotivoHelpBtns();

        initFancyBox().then();
        this.setFavoriteBtnActions();
    },
    mobileFichaReplacements() {
        if (isMobileDevice) {
            const favBtn = document.querySelector('#mainDetailsSection #btnFavorite');
            if(favBtn) {
                const container = document.querySelector('#destkopVerWebButtonContainer');
                if(container) container.appendChild(favBtn);
                favBtn.classList.remove('d-none', 'd-lg-block');
                favBtn.classList.add('d-flex');
            }

            const storiesBtn = document.querySelector('#mainDetailsSection .ficha-story-btn');
            const container = document.querySelector('#destkopVerWebButtonContainer > .ficha-img-floating-btns');
            if(container && storiesBtn) container.appendChild(storiesBtn);

            window.fichaFn.shareBtnGalleryImages();
        }
    },
    setFavoriteBtnActions() {
        document.querySelectorAll('.fav-ico')
            .forEach((favIcon) => {
                const fav = favIcon.closest('[data-id]');
                if(!fav) return;

                if(favoritesFn.isFavorite(fav.getAttribute('data-id'))) fav.classList.add('isfav');
                favIcon.addEventListener('click', favoriteFicha);
            });
    },
    scrollEventFicha(container, cb) {
        if(!container) return;
        container.addEventListener('scroll', cb, { once: true });
    },
    async getReportAdDesk() {
        const id = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        if(isMobileDevice) return false;

        const response = await fetch(`${window.HTML_ROOT}/ajax/get-report-ad-desk?id=${id}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        });

        const body = await response.text();

        if(document.querySelector('#reportAdSection')) return;
        let currentId = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        if(currentId !== id) return;

        const container = document.querySelector('.reportAdSection-container');
        if(container) container.innerHTML = body;

        this.bindMotivoHelpBtns();
        this.reportAdInputListener();
    },
    getMapSection: async function () {
        const id = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        const adUpdatedAt = document.querySelector('#ad-updated-at');
        if(!adUpdatedAt || !adUpdatedAt.value) return;

        const response = await fetch(`${window.HTML_ROOT}/ajax/map-section/${ id}?_=${adUpdatedAt.value}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        });

        const body = await response.text();
        // Fix duplicados
        if (document.querySelector('#mapSection')) return false;
        let currentId = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        if (currentId !== id) return false;

        const container = document.querySelector('.mapSection-container');
        if (container) container.innerHTML = body;
    },
    async toggleDescriptionCollapse() {
        const element = document.querySelector('#textDescriptionMobile');
        const label = document.querySelector('.ficha-description-read-more span');

        if(element && label)
            if(element.classList.contains('collapse'))
                translate({str: 'Leia menos', element: label});
            else
                translate({str: 'Ler mais', element: label});

        if(!element || element.getAttribute('data-collapsable') !== 'true')
            return;

        document.querySelectorAll('#textDescriptionMobile').forEach(item => {
            if(item.classList.contains('collapse')) item.classList.remove('collapse');
            else item.classList.add('collapse');
        });
    },
    shareBtnGalleryImages() {
        // if(!navigator.canShare) return;
        const images = document.querySelectorAll('.image-gallery-container');
        Array.from(images).forEach(image => {
            if(image.querySelector('.gallery-image-share-icon')) return;

            const shareIcon = document.createElement('div');
            shareIcon.className = 'gallery-image-share-icon';
            shareIcon.addEventListener('click', () => fichaFn.shareNative());

            image.append(shareIcon);
            image.style.position = 'relative';
        });
    },
    async shareNative() {
        if(fichaFn.settingsModal)
            fichaFn.settingsModal.hide();

        const shareData = {
            title: window.projectSettingsOptions.projectName,
            text: translate({str: 'Olha o que eu tenho para você'}),
            url: window.location.href,
        };

        if (navigator.share)
            navigator.share(shareData).then();
    },
    getRelatedFichas: async () => {
        const id = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        const swiperConfig = {
            init: true,
            slidesPerView: 2.5,
            spaceBetween: 20,
            freeMode: true,
            preloadImages: false,
            breakpoints: {
                600: {
                    freeMode: false,
                    slidesPerView: 5.5,
                    spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        const swiperConfigPayment = {
            init: true,
            slidesPerView: 'auto',
            preloadImages: false,
            centeredSlides: true,
            centeredSlidesBounds: true,
            breakpoints: {
                992: {
                    centeredSlides: false,
                    freeMode: false,
                    slidesPerView: 'auto',
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };
        if (isMobileDevice) fichaFn.shareBtnGalleryImages();

        const response = await fetch(`${window.HTML_ROOT}/ajax/get-related-fichas?id=${id}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        });
        const body = await response.text();

        const swiperRelatedSelector = window.projectSettingsOptions.autoboostEnabled ?
            '#escortsInterestPaymentSection' : '#escortsInterestSection';

        if (document.querySelector(swiperRelatedSelector)) return false;
        let currentId = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        if (currentId !== id) return false;

        const container = document.querySelector('.relatedEscorts-container');
        if (container) container.innerHTML = body;

        if (
            window.projectSettingsOptions.autoboostEnabled &&
            document.querySelector('.relatedEscorts-container .swiper-container')
        )
            document.querySelector('.relatedEscorts-container').style.background = '#c20b0b';

        new Swiper(
            `${swiperRelatedSelector} .swiper-container`,
            window.projectSettingsOptions.autoboostEnabled ? swiperConfigPayment : swiperConfig
        );

        favoritesFn.markFavoriteHearts();
        document.querySelectorAll('.relatedEscorts-container .fav-ico')
            .forEach(favIco => favIco.addEventListener('click', favoriteFicha));
    },
    bindMotivoHelpBtns() {
        document.querySelectorAll('.motivo-help-button').forEach((motivoHelpBtn) => {
            motivoHelpBtn.addEventListener('mouseover', (event) => {
                let tooltip = this.showReportHelpTooltip(event, motivoHelpBtn);
                motivoHelpBtn.addEventListener('mouseout', () => tooltip.remove());
                document.querySelector('#ad_modal')
                    .addEventListener('scroll', () => tooltip.remove());
                window.addEventListener('scroll', () => tooltip.remove());
            });
        });
    },
    showReportHelpTooltip(e, element) {
        if(!element.hasAttribute('data-descripcion')) return false;
        const { x, y, width, height } = element.getBoundingClientRect();
        const clientX = x + (width / 2);
        const clientY = y + (height / 2) - 4; // -4 is the margin top
        const text = element.getAttribute('data-descripcion');
        return renderTooltip(clientX, clientY, text);
    },
    reportAdInputListener() {
        const buttons = document.querySelectorAll('.motivo-button');
        buttons.forEach(button => {
            button.addEventListener('click', (e) => fichaFn.setMotivoReportAd(e, button, buttons));
        });
    },
    setMotivoReportAd(e, button, buttons) {
        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        fichaFn.reportMotivoId = button.getAttribute('data-id');
    },
    reportAdChangeStep(step) {
        const steps = document.querySelectorAll('.report-step');
        steps.forEach(step => step.classList.remove('active'));

        const item = Object.values(steps).find((item) => {
            if(item.hasAttribute('data-step') && item.getAttribute('data-step') === step.toString()) return item;
        });

        if(item) item.classList.add('active');
    },
    reportMotivoId: '',
    reportDesc: '',
    setMotivoReportAdMobile(motivo, id) {
        fichaFn.reportMotivoId = id;
        document.querySelector('#showMotivoNombre').innerHTML = motivo;
        fichaFn.reportAdChangeStep(2);
    },
    setVideoGaEvent() {
        document.querySelectorAll('#imageVideoSection video').forEach(video => {
            video.addEventListener('play', () => {
                const el = document.querySelector('#ad_modal');
                const id = el && el.hasAttribute('data-ficha-id') ? el.getAttribute('data-ficha-id') : '';
                customGa('video', 'playVideo', id);
                if (window.localStorage && window.localStorage.getItem('dimension5') !== 'si') customGaSetDimension('dimension5', 'si');
            });

            video.addEventListener('pause', () => {
                const el = document.querySelector('#ad_modal');
                const id = el && el.hasAttribute('data-ficha-id') ? el.getAttribute('data-ficha-id') : '';
                customGa('video', 'pauseVideo', parseInt(id));
            });
        });
    },
    openReportModal() {
        const cb = () => {
            if(this.settingsModal) this.settingsModal.hide();
            this.reportModal.show();
        };

        if(this.hasReportModal) {
            cb();
            return false;
        }

        this.getReportModal().then(cb);
    },
    async parseFichaDate() {
        const timestamp = parseInt(document.querySelector('.fecha-creacion span').textContent) * 1000;
        const dateSpan = document.querySelector('.fecha-creacion span');
        const now = new Date();
        const threeMonth = now.setMonth(now.getMonth() - 3);
        // const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if(timestamp < threeMonth) {
            translate({str: 'Há mais de 3 meses', element: dateSpan});
        } else {
            const date = new Date(timestamp);
            dateSpan.textContent = ('0' + date.getUTCDate()).slice(-2) +'/'+
                ('0' + (date.getMonth() + 1)).slice(-2) +'/'+
                date.getFullYear() +' '+
                ('0' + date.getHours()).slice(-2) +':'+
                ('0' + date.getMinutes()).slice(-2);
        }
        dateSpan.style.color = '';
    },
    async sendReportAd(event) {
        event.preventDefault();
        const text = isMobileDevice ? fichaFn.reportDesc : document.querySelector('.motivo-desc-container textarea').value;

        const id = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        if(!fichaFn.reportMotivoId) {
            const selector = isMobileDevice ? '.report-step[data-step="3"] .motivo-row' : '#reportForm .motivo-container .motivo';
            const { y } = document.querySelector(selector).getBoundingClientRect();
            const x = window.innerWidth / 2;
            renderTooltip(x, y, translate({str: 'Revise o campo do motivo'}));
            return;
        }

        const formData = new FormData();
        formData.append('ficha_id', id);
        formData.append('motivo_id', fichaFn.reportMotivoId);
        formData.append('texto', text);

        const response = await fetch(`${window.HTML_ROOT}/report-ad`, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            body: formData
        });
        const body = await response.json();

        if(body.success === 0)
            showToastMsg(translate({str: 'Ha ocurrido un error, compruebe de nuevo mas tarde'}));

        if(isMobileDevice) {
            document.querySelector('#horaRelatorio').innerHTML = body.time;
        } else {
            document.querySelector('#reportForm').style.display = 'none';
            document.querySelector("#reportAdSection .success-msg").style.display = 'flex';
        }

        const gaValue = document.querySelector('[name="report[ad]"]');
        if(gaValue) customGa('denunciarAnuncio', 'formOK', gaValue.value);
        fichaFn.reportAdChangeStep(4);
    },
    favoriteSliderTap() {
        console.log('fired favoriteSliderTap');
        const sliderHeartEl = document.querySelector('.slider-like-heart.into-slider');
        const svg = sliderHeartEl.querySelector('svg');
        const externalFav = sliderHeartEl.parentElement.querySelector('#btnFavorite');

        sliderHeartEl.addEventListener('animationend', () => {
            svg.classList.remove('active');
        }, {once: true});

        if (!externalFav.classList.contains('isfav')) {
            const curAdID = externalFav.getAttribute('data-id');
            addFavorite(curAdID);
            sliderHeartEl.querySelector('svg').classList.add('active');
            document.querySelectorAll('.fav-ico[data-id=" + curAdID + "]').forEach(favIco => favIco.classList.add('isfav'));
        }
    },
    getReportModal() {
        return new Promise((resolve) => {
            fetch(`${window.HTML_ROOT}/get-report-modal`, {
                method: 'GET',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            }).then(response => response.text().then(body => {
                const container = document.querySelector('section#frame');
                const frag = document.createRange().createContextualFragment(body);
                if(container) container.appendChild(frag);

                SVGLoader();
                fichaFn.reportAdInputListener();

                this.reportModalElement = document.querySelector('#reportModal');
                this.reportModal = new Modal(this.reportModalElement);
                this.hasReportModal = true;

                resolve();
            }));
        });
    },
    async setMotivoDescReportAdMobile() {
        const element = document.querySelector('.report-step[data-step="2"] textarea');

        if(element.value.length < 10) {
            showToastMsg(translate({str: 'Mínimo 10 caracteres'}));
            return;
        }

        window.reportDesc = fichaFn.value;
        document.querySelector('#showMotivoDesc').innerHTML = element.value;

        fichaFn.reportAdChangeStep(3);
    },
    closeReportModal() {
        if(!this.reportModal) return;
        this.reportModal.hide();
        this.reportModalElement.classList.remove('show');

        document.querySelector('.report-step[data-step="2"] textarea').value = '';
        fichaFn.reportAdChangeStep(1);
    },
    closeBoostModal() {
        if(!this.boostModal) return;
        fichaFn.boostModal.hide();
        boostAdChangeStep(1);
    },
    openBoostModal() {
        const cb = () => {
            if(isMobileDevice) fichaFn.settingsModal.hide();
            fichaFn.boostModal.show();
        };

        if(!fichaFn.hasBoostModal) this.getBoostModal().then(cb);
        else cb();
    },
    async getBoostModal() {
        const id = document.querySelector('#ad_modal') ?
            document.querySelector('#ad_modal').getAttribute('data-ficha-id')
            : document.querySelector('#btnFavorite').getAttribute('data-id');

        const response = await fetch(`${window.HTML_ROOT}/get-boost-modal?id=${id}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        });
        const body = await response.text();
        const frag = document.createRange().createContextualFragment(body);
        document.querySelector('section#frame').appendChild(frag);
        SVGLoader();

        fichaFn.boostModalElement = document.querySelector('#boostModal');
        fichaFn.boostModal = new Modal(fichaFn.boostModalElement);
        fichaFn.hasBoostModal = true;
    },
    reportBtnClickHandler() {
        event.stopPropagation();

        if(isMobileDevice) fichaFn.openReportModal();
    },
    playAudio(element) {
        if(element.classList.contains('active'))
            this.stopAudio();
        else {
            this.audio = new Audio(document.querySelector('[data-audio-url]').getAttribute('data-audio-url'));
            this.audio.addEventListener('ended', () => this.stopAudio());
            this.audio.play();
            element.classList.add('active');
        }
    },
    stopAudio() {
        const element = document.querySelector('.ficha-play-audio-btn');
        if(!element) return;

        element.classList.remove('active');

        if(!this.audio) return;

        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio = undefined;
    }
};
window.fichaFn = fichaFn;
